import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-address-text',
  template: `
    <span class="address" [class.wrap]="wrap" [ngbTooltip]="wrap || !address ? null : fullAddress" container="body"
          [appCopyOnClick]="wrap ? null : address" [copyMessage]="'COMMON.TEXT_COPIED' | translate">{{ address || '-' }}</span>
    <ng-template #fullAddress>{{ address }}<br><small>{{ 'COMMON.CLICK_TO_COPY' | translate }}</small></ng-template>
  `,
  styles: [`
    :host {
      display: block;
      min-width: 0;
    }
    .address {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      /* Globalna reguła dla span w app.component.scss przebija kolor odziedziczony po rodzicu. */
      color: inherit;
    }
    /* Okno alarmu: ratownik musi widzieć cały adres od razu, bez najeżdżania */
    .address.wrap {
      white-space: normal;
      overflow-wrap: anywhere;
    }
  `]
})
export class AddressTextComponent {

  @Input() address: string;

  /** Cały adres w kilku liniach zamiast jednej uciętej. */
  @Input() wrap = false;
}
